import $ from '../$';
import './each';
$.fn.empty = function () {
    return this.each(function () {
        this.innerHTML = '';
    });
};
